import { AddressType } from 'types';
import { baseQuery } from '../baseQuery';

type SuburbSearchParams = {
  value: string;
  type?: AddressType;
};

export const getSuburb = async ({ value, type = AddressType.Physical }: SuburbSearchParams) => {
  const { data } = await baseQuery(
    `suburbs?search_value=${value}&per_page=150${type === AddressType.Postal ? '&exclude_po_box_types=0' : ''}`,
  );

  return data;
};
